import axios from "axios";
import fruitDemo, { fruitData } from "./data";
import { checkBalanceColor, gameAssets, instances, parseJackpotResult, pendingGameUpdate, setSessionExpired, showErrorPopup, showGrandJackpotWin, showMajorJackpotWin, showMinorJackpotWin, toggleButtons, updateBalance } from "./gameUI";
import { generateClientSeed } from "../../../utils/common.helper";
import { handleWinOrLoss, toggleVisibiltiyAndInteractivity, updateBucketAmount } from "./gameLogic";
import { playMainBg, playMainBg1, playMainBg2 } from "./soundManager";
import { demoData, placeBetSimulator } from "./demoSimulator";

let connected = false;
let placingBet = false;


export async function createConnection(baseUrl) {
    fruitData.baseUrl = baseUrl;

    if (fruitDemo.isDemo) {
        getDemoGameData()
        return;
    }
    if (
        fruitData.currencyCode &&
        fruitData.operatorId &&
        fruitData.accessToken &&
        fruitData.gameCode
    ) {
        // getJwtToken()
    }
    else {
        // console.error(`Error in currencyCode: ${fruitData.currencyCode}, operatorId: ${fruitData.operatorId}, accessToken: ${fruitData.accessToken} or gameCode: ${fruitData.gameCode}`)
    }
}

function getDemoGameData() {
    fruitData.gameLanguage = "en"
    fruitData.balance = demoData.userInfo.balance
    fruitData.betSettings = demoData.betInfo.betSettings
    fruitData.betSettings.sort((a, b) => a - b);
   
    fruitData.isNewUser = demoData.userInfo.isNewUser
    fruitData.roundSettings = demoData.roundInfo.roundSettings
    fruitData.roundSettings.sort((a, b) => a - b);
    if (gameAssets?.balanceAmount?.text) gameAssets.balanceAmount.text = fruitData.balance
}

export async function getFruitToken() {
    const data = {
        currencyCode: fruitData.currencyCode,
        operatorId: fruitData.operatorId,
        operatorUserToken: fruitData.accessToken,
        gameId: fruitData.gameCode
    }
    try {
        if (fruitData.response) {
            // let res = JSON.parse(window.atob(sessionStorage.getItem('tk')))
            storeLoginResponse(fruitData.response);

        }

    } catch (error) {
        // console.error(error)
    }
}

export async function setLanguage(lang = "en") {

    if (fruitDemo.isDemo) return

    fruitData.gameLanguage = lang

    const data = {
        "language": lang
    }
    try {
        const response = await axios.post(fruitData.baseUrl + '/user/update-language-status', data);


    } catch (error) {
    }
}

export async function checkForPendingGame() {
    if (!fruitDemo.isDemo)
        checkForToken();
    else
        startNewGame()

    //   handleGameState(gameStates.IDLE)
}

async function getBets() {
    axios.defaults.headers.Authorization = `bearer ${fruitData.jwtToken}`;
    // const totalBet = getTotalBet()

    // const data = {
    //     page: "1",
    //     perPage: "2",
    //     filter: ["pending"]
    // }
    // const header = { headers: { Authorization: `bearer ${fruitData.jwtToken}` } }
    // axios.headers = `Bearer ${fruitData.jwtToken}`;
    await axios.get(process.env.REACT_APP_BACKEND_URL_HTTP + '/game/lottery/sliceNGo/get-bets?page=1&perPage=2&filter=pending')
        .then((response) => {
            storeBetsData(response.data)
            //  continueWithBetResult(response.data);
        })
        .catch((error) => {
            console.log("ererer", error);

            //TODO: REMOVE THIS , ONLY FOR TESTING
            if (error?.response?.data?.errors[0]?.name == "InvalidToken" || error?.response?.data?.errors[0]?.fields?.message == 'jwt expired') {
                fruitData.tokenExpired = true
                setTimeout(() => {
                    setSessionExpired();
                }, 1000);

                return;
            }
            showErrorPopup()
        });
}

let networkCounter = 0;
const waitTime = 75;
let error = false;
function checkForToken() {
    setTimeout(() => {
        if (fruitData.jwtToken) {
            getBets();
        } else if (!error) {
            checkForToken();
            networkCounter++
            if (networkCounter > waitTime) {
                setTimeout(() => {
                    setSessionExpired();
                }, 1000);
                // showErrorPopup("Token expired , could not connect to server");
                gameAssets.loadingScreen.children[0].text = "CONNECTION FAILED"
                error = true
            }
        }
    }, 100);
}

function storeBetsData(data) {

    if (data?.data?.bets.length) {
        resumeGame(data)
    }
    else {
        startNewGame();
    }

}

const TYPE_OF_WIN = {
    NONE: 'NONE',
    NORMAL_WIN: 'NORMAL_WIN',
    BIG_WIN: 'BIG_WIN',
    MEGA_WIN: 'MEGA_WIN',
    ULTRA_WIN: 'ULTRA_WIN'
}

function handlePlayDemo() {
    if (instances.Meter.heartText.text == 0) {
        fruitData.gameResult = 'lost';
        handleWinOrLoss();
        demoData.demoPointer = 0;
        return;
    }

    if (demoData.demoPointer == fruitData.totalRounds) {
        demoData.demoPointer = 0;
        fruitData.gameResult = 'won';

        // Count coins and calculate the deviation from half of total rounds
        const coins = fruitData.roundValues.filter(value => value !== 'bomb').length;
        const deviation = Math.abs(Math.ceil(fruitData.totalRounds / 2) - coins);

        // Get the last applicable multiplier based on deviation
        let lastMultiplier = instances.Meter.multipliers[fruitData.totalRounds][deviation - 1] || 0;
        const totalWin = lastMultiplier * fruitData.totalBet;

        // Assign win type based on total winnings
        if (totalWin >= fruitData.totalBet * 100) {
            fruitData.winType = TYPE_OF_WIN.ULTRA_WIN;
        } else if (totalWin >= fruitData.totalBet * 20) {
            fruitData.winType = TYPE_OF_WIN.MEGA_WIN;
        } else if (totalWin >= fruitData.totalBet * 5) {
            fruitData.winType = TYPE_OF_WIN.BIG_WIN;
        } else {
            fruitData.winType = TYPE_OF_WIN.NORMAL_WIN;
        }

        fruitData.roundWinnings = totalWin;
        fruitData.balance += totalWin;
        demoData.userInfo.balance = fruitData.balance

        updateBalance(fruitData.balance);
        if (fruitData.balance >= fruitData.totalBet) checkBalanceColor(false);
        handleWinOrLoss();
    }
}


export async function playGame(fruit) {

    if (fruitDemo.isDemo) {
        demoData.demoPointer += fruit.length;
        handlePlayDemo();
        return;
    }

    axios.defaults.headers.Authorization = `Bearer ${fruitData.jwtToken}`;

    const data = {
        carPosArray: fruit
    };

    // Set a timeout to show the loader after 2 seconds
    // const loaderTimeout = setTimeout(() => {
    //     instances.NetworkLoader?.showLoader();
    // }, 2000);

    // Function to attempt the API call with retry logic
    async function attemptPlayGame() {
        try {
            const response = await axios.post(`${fruitData.baseUrl}/game/lottery/sliceNGo/play-game`, data);

            // If the response comes before 2 seconds, prevent showLoader and call hideLoader
            // clearTimeout(loaderTimeout);
            // instances.NetworkLoader?.hideLoader();

            storeRoundResult(response.data);
        } catch (error) {
            // Clear the timeout so showLoader isn't called if an error happens quickly
            // clearTimeout(loaderTimeout);
            // instances.NetworkLoader?.hideLoader();

            toggleButtons(false)
            fruitData.play = false;
            gameAssets.fruit1.visible = gameAssets.fruit2.visible = false
            if (!error.response) {
                // Network-related error
                // console.error("Network error occurred:", error.message);
                showErrorPopup("INTERNET\nDISCONNECTED!");

                await waitForNetwork();

                // Retry the operation
                await attemptPlayGame(); // Recursive retry
            } else {
                // Handle other errors 
                const errorMessage = error.response?.data.errors[0]?.description || "An error occurred.";
                // console.error("Error during POST request:", error.response);
                if (error.response?.data.errors[0]?.name === "InvalidToken" || error.response?.data.errors[0]?.fields?.message == 'jwt expired') {
                    //  errorOccured(error.message);
                    fruitData.tokenExpired = true;
                    showErrorPopup("Token Expired")
                    return;
                }
                showErrorPopup('NETWORK ERROR');
            }
        }
    }

    await attemptPlayGame();
}

function storeRoundResult(data) {
    fruitData.totalRounds = data?.data?.details?.maxRound;
    fruitData.gameResult = data?.data?.details?.result;
    fruitData.roundWinnings = data.data.details.winningAmount;
    if (fruitData.roundWinnings > 0) {
        fruitData.balance = data?.data?.wallet?.balance;
        updateBalance(fruitData.balance);
    }

    if (fruitData.balance >= fruitData.totalBet) checkBalanceColor(false);

    fruitData.multiplier = data?.data?.details?.roundDetails[data?.data?.details?.roundDetails.length - 1].awardMulti;
    fruitData.winType = data?.data?.details?.typeOfWin;
    fruitData.prizeUpgrade = data?.data?.details?.prizeUpgrade

    if (fruitData?.gameResult !== 'pending') {
        handleWinOrLoss()
    }
    // fruitData.jackpot  = 
    // handleGameState(fruitData.currentGameState);
    // if (gameAssets?.balanceValueText?.text && data?.data?.wallet?.balance) gameAssets.balanceValueText.text = data.data.wallet.balance
}


function resumeGame(data) {
    const bet = data?.data?.bets[0] || {};
    const betAmount = Number(bet.betAmount || 0);
    const bombCount = bet.carDirection?.filter(v => v === "bomb").length || 0;

    fruitData.betPointer = fruitData.betSettings.findIndex(item => item === betAmount);

    const decimalPart = Math.floor((betAmount * 10) % 10);
    fruitData.roundValues = bet.roundValues;
    fruitData.bomb = bombCount;
    fruitData.totalRounds = bet.maxRound;
    fruitData.tierOneCeil = Math.ceil(fruitData.totalRounds / 2);
    if ((!fruitData.totalRounds % 2)) fruitData.tierOneCeil = fruitData.tierOneCeil + 1;

    fruitData.tierPointer = bet.carDirection?.length - bombCount;

    // Update heart text
    instances.Meter.heartText.text = instances.Meter.multipliers[bet.maxRound].length - bombCount;
    if (instances.Meter.heartText.text < 2) {
        instances.Meter.pulsateHeart(true);
        instances.Meter.heartText.style.fill = '#FFFF00';
    }

    // Handle bucket pointer based on game state
    if (fruitData.totalRounds >= 9 && fruitData.tierPointer > fruitData.totalRounds - 2) {
        fruitData.tierOneHit = false;
        fruitData.tierTwoHit = false;
        playMainBg2(true);
        fruitData.bucketPointer = instances.Meter.multipliers[bet.maxRound].length - 2;
        updateBucketAmount(false);
        fruitData.bucketPointer += 1;
    } else if (fruitData.tierOneCeil < fruitData.tierPointer) {
        fruitData.tierOneHit = false;
        const temp = fruitData.totalRounds - fruitData.tierPointer;
        fruitData.bucketPointer = instances.Meter.multipliers[bet.maxRound].length - temp - 1;
        updateBucketAmount(false);
        fruitData.bucketPointer += 1;
        playMainBg1(true);
    } else {
        playMainBg(true);
    }

    // Update UI texts
    const formattedAmount = decimalPart === 0 ? Math.floor(betAmount) : betAmount.toFixed(1);
    gameAssets.betText.text = gameAssets.betAmount.text = formattedAmount;
    gameAssets.startText.text = 'NEXT SLICE\nCHEF!';
    gameAssets.playButtonText.visible = true;

    const roundDetailsLength = bet.roundDetails?.length ?? 0;
    gameAssets.playButtonText.text = bet.maxRound - roundDetailsLength;
    gameAssets.roundPanelText.text = bet.maxRound;
    fruitData.roundPointer = fruitData.roundSettings.findIndex(item => item === fruitData.totalRounds);
    fruitData.currentRound = roundDetailsLength;
    fruitData.previousFruit = bet.carDirection?.filter(v => v !== "bomb") || [];
    instances.Meter.meterHolder[bet.maxRound].visible = true;
    instances.Meter.createMultipliers(bet.maxRound);
    instances.Meter.meterHolder[bet.maxRound].addChild(instances.Meter.meterFruitContainer);

    if (fruitData.previousFruit.length > 0) {
        instances.Meter.addFruit(fruitData.previousFruit);
    }

    toggleVisibiltiyAndInteractivity(false);
    fruitData.placeBet = false;
    pendingGameUpdate();

    if (fruitData.balance < betAmount) {
        checkBalanceColor(true);
    }

    if (data?.data?.jackpotDetails?.length > 0)
        handlePendingJackpotDetails(data.data.jackpotDetails)
}

function handlePendingJackpotDetails(jackpotDetails) {
    const len = jackpotDetails.length
    for (let i = 0; i < len; i++) {
        if (jackpotDetails[i]?.description === "Minor") {
            fruitData.jackpotMinorWin = fruitData.minorFlag = true
            fruitData.jackpotMinorWinAmount = jackpotDetails[i].amount
            fruitData.resetMinorJackpotValue = jackpotDetails[i].jackpotBeforeTrigger

            showMinorJackpotWin(fruitData.jackpotMinorWinAmount, 4)
        } else if (jackpotDetails[i]?.description === "Major") {
            fruitData.jackpotMajorWin = fruitData.majorFlag = true
            fruitData.jackpotMajorWinAmount = jackpotDetails[i].amount
            fruitData.resetMajorJackpotValue = jackpotDetails[i].jackpotBeforeTrigger
            showMajorJackpotWin(fruitData.jackpotMajorWinAmount, 4)
        } else if (jackpotDetails[i]?.description === "Grand") {
            fruitData.jackpotGrandWin = fruitData.grandFlag = true;
            fruitData.jackpotGrandWinAmount = jackpotDetails[i].amount
            fruitData.resetGrandJackpotValue = jackpotDetails[i].jackpotBeforeTrigger
            showGrandJackpotWin(fruitData.jackpotGrandWinAmount, 4)
        }
    }
    parseJackpotResult();
}


function startNewGame() {
    fruitData.placeBet = true;
    instances.Meter.meterHolder[fruitData.roundSettings[0]].visible = true;
    instances.Meter.createMultipliers(fruitData.roundSettings[0]);
    instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.roundSettings[fruitData.roundPointer]].length

    gameAssets.betText.text = fruitData.betSettings[fruitData.betPointer];
    gameAssets.betAmount.text = fruitData.betSettings[fruitData.betPointer];
    gameAssets.roundPanelText.text = 'SLICES'
    fruitData.totalRounds = fruitData.roundSettings[0];

    if (fruitData.balance < fruitData.betSettings[fruitData.betPointer]) {
        checkBalanceColor(true);
    }
    playMainBg(true);
    pendingGameUpdate();
}

export const getTotalBet = () =>
    fruitData.totalBet = fruitData.betSettings[fruitData.betPointer]

export async function placeBet() {
    axios.defaults.headers.Authorization = `bearer ${fruitData.jwtToken}`;
    const totalBet = getTotalBet();

    if (fruitDemo.isDemo) {

        if (fruitData.balance < totalBet) {
            showErrorPopup('INSUFFICIENT\nBALANCE')
            return Promise.reject(new Error('Insufficient balance'));
        }

        console.log("ebebe", totalBet);
        
        placeBetDemoGame(fruitData.totalRounds, totalBet);

        setTimeout(() => {
            placingBet = false;
        }, 1000);
        return;
    }

    const data = {
        clientSeed: generateClientSeed()?.seed,
        noOfRounds: fruitData.totalRounds,
        betAmount: totalBet ? totalBet : 10,
    };

    // Set a timeout for 2 seconds to show the loader
    // const loaderTimeout = setTimeout(() => {
    //     instances.NetworkLoader?.showLoader();
    // }, 1500);    

    try {
        const response = await axios.post(fruitData.baseUrl + '/game/lottery/sliceNGo/place-bet', data);

        // If the response comes before 2 seconds, prevent showLoader and call hideLoader
        // clearTimeout(loaderTimeout);
        // instances.NetworkLoader?.hideLoader()

        continueWithBetResult(response.data);

        setTimeout(() => {
            placingBet = false;
        }, 2000);
    } catch (error) {
        console.log("error", error?.response);
        toggleButtons(false)

        if(error?.response?.data?.errors[0]?.description === "USER_IS_BLOCKED"){
            showErrorPopup('USER BLOCKED');
            throw error;
            
        }
        else if (error?.response?.data?.errors[0]?.description === "INVALID_TOKEN" || error?.response?.data?.errors[0]?.fields?.message == 'jwt expired') {
            fruitData.tokenExpired = true;
            showErrorPopup("Token expired");

            setTimeout(()=>{
                setSessionExpired()
            }, 1200)
            throw error;
        }
        else if (error?.response?.data?.errors[0]?.description === "PREVIOUS_BET_NOT_COMPLETED") {
            showErrorPopup("PREVIOUS BET\nNOT COMPLETED");
            throw error;
        } else if (error?.response?.data?.errors[0]?.description == 'INSUFFICIENT_FUNDS') {
            showErrorPopup('INSUFFICIENT \nBALANCE')
            throw error;
        }
        else if (!error?.response) {
            showErrorPopup("INTERNET \nDISCONNECTED");
            await waitForNetwork();
            await placeBet();
            throw error;
        }

        showErrorPopup();
        throw error; // fallback
    }

}

function placeBetDemoGame(totalRounds, totalBet) {
    fruitData.balance = placeBetSimulator(totalRounds, totalBet)
    fruitData.jackpot = false;
    updateBalance(fruitData.balance);

    if (fruitData.balance < fruitData.betSettings[fruitData.betPointer]) {
        checkBalanceColor(true);
    }
}

function continueWithBetResult(data) {
    fruitData.balance = data?.data?.wallet?.balance ?? 0;
    fruitData.roundValues = data?.data?.details?.roundValues;
    updateBalance(fruitData.balance);
    if (fruitData.balance < fruitData.betSettings[fruitData.betPointer]) {
        checkBalanceColor(true);
    }
    // handleGameState(fruitData.currentGameState);
    if (data.data.jackpotDetails.length > 0) {
        handleJackpotDetails(data.data.jackpotDetails)
        handleJackpotPanel(data.data.jackpotDetails)
    }
    else fruitData.jackpot = false;
    // if (gameAssets?.balanceValueText?.text) gameAssets.balanceValueText.text = data.data.wallet.balance
}

function waitForNetwork() {
    return new Promise((resolve) => {
        function checkNetwork() {
            if (navigator.onLine) {
                // Network is back online
                // instances.PopUpMessage.closePopUp()
                window.removeEventListener('online', checkNetwork);
                resolve();
            }
        }

        // Add an event listener to detect when the network is back
        window.addEventListener('online', checkNetwork);

        // Optionally, check the network periodically
        const interval = setInterval(() => {
            if (navigator.onLine) {
                clearInterval(interval);
                // instances.PopUpMessage.closePopUp()
                window.removeEventListener('online', checkNetwork);
                resolve();
            }
        }, 1000);
    });
}

export async function betHistory() {

    if (fruitDemo.isDemo) {
        return;
    }

    axios.defaults.headers.Authorization = `Bearer ${fruitData.jwtToken}`;

    await axios.get(process.env.REACT_APP_BACKEND_URL_HTTP + `/user/bet-history?page=1&perPage=10&gameId=${fruitData.gameCode}`)
        .then((response) => {
            const tempArray = response?.data?.data?.rows?.map(({ bet_amount, slices, createdat, result, winning_amount, beforebalance, afterbalance, prize_upgrade }) => {
                const dateObj = new Date(createdat);
                const car_direction = slices

                const date = dateObj.toLocaleDateString('en-CA');
                const time = dateObj.toLocaleTimeString('en-GB');

                return {
                    bet_amount,
                    result,
                    date,
                    car_direction,
                    time,
                    winning_amount,
                    beforebalance,
                    afterbalance,
                    prize_upgrade
                };
            });

            console.log("RESPONSE BET HISTORY", tempArray);
            fruitData.betHist = tempArray;

            if (tempArray.length) instances.MenuPopUp.populateRows();
            return;

        }).catch((error) => {
            console.log("BET HISTORY API ERROR", error, error?.response?.data?.errors[0]?.description, error?.response?.data?.errors[0]?.fields?.message);

            if (error?.response?.data?.errors[0]?.description == 'Either access token not passed or it is expired' || error?.response?.data?.errors[0]?.fields?.message == 'jwt expired') {
                showErrorPopup('Token Expired!');
                return;
            }
            showErrorPopup("Network Error");
        })
}

function storeLoginResponse(data) {
    fruitData.userId = data.data.user.id;
    fruitData.gameLanguage = data.data.user.language;
    //  console.log("game language:", data.data.user.language);
    if (!fruitData.jwtToken) fruitData.jwtToken = data.data.accessToken;

    fruitData.balance = data.data.wallet.balance

    fruitData.showAutoAndTurbo = data.data.gameSettings.enableAutoplayTurbo;
    fruitData.betSettings = data.data.gameSettings.validBetArray
    fruitData.betSettings.sort((a, b) => a - b);
    //  console.log("bet settings:", fruitData.betSettings)

    fruitData.betMultiplier = data.data.gameSettings.betValue

    fruitData.isNewUser = data.data.isNewUser

    fruitData.roundSettings = data.data.gameSettings.numberOfRounds;
    fruitData.roundSettings.sort((a, b) => a - b);

    fruitData.isJackpotActive = data.data.gameSettings.isJackpotActive

    if (data.data.gameSettings.jackpotDetails.JackpotTiers) {
        //  console.log("Jackpot", data.data.gameSettings.jackpotDetails);
        fruitData.grandCurrentJackpotValue = data.data.gameSettings.jackpotDetails.JackpotTiers[2].currentValue
        fruitData.majorCurrentJackpotValue = data.data.gameSettings.jackpotDetails.JackpotTiers[0].currentValue
        fruitData.minorCurrentJackpotValue = data.data.gameSettings.jackpotDetails.JackpotTiers[1].currentValue
        // console.log("jackpot details", fruitData.grandCurrentJackpotValue, " ", fruitData.majorCurrentJackpotValue, " ", fruitData.minorCurrentJackpotValue)
    }
    else {
        console.log("no JackpotTiers details");
        //  fruitData.jackpot = false;
    }

    //   console.log('Data received here:', fruitData.minBet, fruitData.maxBet, fruitData.roundSettings);
    // if (gameAssets?.balanceAmount?.text) updateBalance(fruitData.balance)
    connected = true;
    // console.log(fruitData.jwtToken, " jwt token")
}

export async function isOnline(timeout = 3000) {
    if (fruitDemo.isDemo) return true;
    if (!navigator.onLine) return false; // First, check browser's built-in online status

    // const loaderTimeout = setTimeout(() => {
    //     instances.NetworkLoader?.showLoader();
    // }, 750);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
        const response = await fetch(process.env.REACT_APP_HEALTH_CHECK_API + '/health-check', {
            method: "GET",
            cache: "no-store",
            signal: controller.signal, // Attach the timeout
        });
        // instances.NetworkLoader?.hideLoader();
        clearTimeout(timeoutId);
        // clearTimeout(loaderTimeout);
        return response.ok;
    } catch (error) {
        // instances.NetworkLoader?.hideLoader();
        clearTimeout(timeoutId);
        // clearTimeout(loaderTimeout);
        return false; // If fetch fails or times out, assume offline
    }
    // return true
}

export function setSliceNGoJackpotDataWs(data, userId) {
    if (userId == fruitData.userId) {
        handleJackpotDetails(data)
        handleJackpotPanel(data)
    }
    else {
        handleJackpotDetails(data);

        fruitData.grandCurrentJackpotValue = data[2].data.currentValue;
        fruitData.majorCurrentJackpotValue = data[0].data.currentValue;
        fruitData.minorCurrentJackpotValue = data[1].data.currentValue;

        fruitData.resetGrandJackpotValue = data[2].data.jackpotBeforeTrigger;
        fruitData.resetMajorJackpotValue = data[0].data.jackpotBeforeTrigger;
        fruitData.resetMinorJackpotValue = data[1].data.jackpotBeforeTrigger;

        if (!fruitData.jackpotGrandWin) {
            showGrandJackpotWin(fruitData.grandCurrentJackpotValue, 4);
        } else {
            showGrandJackpotWin(fruitData.resetGrandJackpotValue, 4);
        }

        if (!fruitData.jackpotMajorWin) {
            showMajorJackpotWin(fruitData.majorCurrentJackpotValue, 4);
        } else {
            showMajorJackpotWin(fruitData.resetMajorJackpotValue, 4)
        }

        if (!fruitData.jackpotMinorWin) {
            showMinorJackpotWin(fruitData.minorCurrentJackpotValue, 4)
        } else {
            showMinorJackpotWin(fruitData.resetMinorJackpotValue, 4)
        }
    }
}
function handleJackpotPanel(jackpotDetails) {
    fruitData.grandCurrentJackpotValue = jackpotDetails[2].data.currentValue;
    fruitData.majorCurrentJackpotValue = jackpotDetails[0].data.currentValue;
    fruitData.minorCurrentJackpotValue = jackpotDetails[1].data.currentValue;

    fruitData.resetGrandJackpotValue = jackpotDetails[2].data.jackpotBeforeTrigger;
    fruitData.resetMajorJackpotValue = jackpotDetails[0].data.jackpotBeforeTrigger;
    fruitData.resetMinorJackpotValue = jackpotDetails[1].data.jackpotBeforeTrigger;


    showMinorJackpotWin(fruitData.jackpotMinorWin ? fruitData.jackpotMinorWinAmount : fruitData.minorCurrentJackpotValue, 4);
    showMajorJackpotWin(fruitData.jackpotMajorWin ? fruitData.jackpotMajorWinAmount : fruitData.majorCurrentJackpotValue, 4);
    showGrandJackpotWin(fruitData.jackpotGrandWin ? fruitData.jackpotGrandWinAmount : fruitData.grandCurrentJackpotValue, 4);
}

function handleJackpotDetails(jackpotDetails) {
    // console.log("wehdhjewbfhewbfhb", jackpotDetails[0].data.wonAmount);
    fruitData.jackpotDetails = jackpotDetails

    fruitData.jackpotMinorWin = fruitData.minorFlag = jackpotDetails[1].data.won
    fruitData.jackpotMajorWin = fruitData.majorFlag = jackpotDetails[0].data.won
    fruitData.jackpotGrandWin = fruitData.grandFlag = jackpotDetails[2].data.won

    fruitData.jackpotMinorWinAmount = jackpotDetails[1].data.wonAmount
    fruitData.jackpotMajorWinAmount = jackpotDetails[0].data.wonAmount
    fruitData.jackpotGrandWinAmount = jackpotDetails[2].data.wonAmount

    parseJackpotResult();
}